import * as Yup from 'yup';
import { Gender } from '../../../enums';

const schema = Yup.object({
  name: Yup.string().trim().required('Name is required'),
  email: Yup.string()
    .trim()
    .email('Invalid email format')
    .required('Email is required'),
  gender: Yup.mixed<Gender>()
    .oneOf([Gender.MALE, Gender.FEMALE], 'Gender is required')
    .required('Gender is required')
});

export default schema;
